import Page from "page/Page";
import $ from "jquery";


$(function () {
    if ($("body").is("[data-page]")) {
        window.currentPage = new Page($("body").attr("data-page"));
    }
});
